import { render, staticRenderFns } from "./TipiDocumentoIdentita.vue?vue&type=template&id=534a3f21&"
import script from "./TipiDocumentoIdentita.vue?vue&type=script&lang=ts&"
export * from "./TipiDocumentoIdentita.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports